import React from "react";
import { ROLE } from "Common/constants/roles";
import ProductionItemsPage from "Common/Components/ProductionItemsPage";

// کالاهای بارگیری شده = قلم‌هایی که item_status آن‌ها loaded است.
// کارشناس فروش با advance-status قلم بارگیری‌شده را به مشتری تحویل می‌دهد.
const Index = () => (
  <ProductionItemsPage
    pageTitle="کالاهای بارگیری شده"
    itemStatus="loaded"
    advanceLabel="تحویل مشتری"
    advanceConfirmText={(item) =>
      `آیا تحویل کالای «${item.goods_full_description || item.goods_description || item.goods_title || item.goods_code || `شماره ${item.line_number ?? item.id}`}» برای مشتری «${item.customer_name || "-"}» را تأیید می‌کنید؟`
    }
    advanceSuccessText="تحویل کالا ثبت شد"
    advanceRoles={[ROLE.SALES_EXPERT]}
    canRevert
    revertRoles={[]}
    emptyText="هیچ کالای بارگیری‌شده‌ای نیست"
  />
);

export default Index;
